export const getScheduleCollaboratorInitialState = {
	schedules: null,
	error: null,
	errorShow: false,
	loading: false,
};
